import { render, staticRenderFns } from "./PxShowTipoProduto.vue?vue&type=template&id=c274b25e&"
import script from "./PxShowTipoProduto.vue?vue&type=script&lang=js&"
export * from "./PxShowTipoProduto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports